module.exports = __webpack_public_path__ + "res/28-img_game_bg_end.d84503e3546404a6b2559c8286ce03b3.png";